Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK_VERSION = '6.17.2';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/core/dist/version.js
// module id = 744
// module chunks = 0